const ko = {
  meta: { code: "ko", label: "한국어" },
  nav: {
    brand: "IQ Log",
    diagnostics: "진단",
    mypage: "마이 페이지",
    login: "로그인",
    register: "회원가입",
    logout: "로그아웃",
  },
  hero: {
    eyebrow: "진단 플랫폼",
    title: "진단으로 발견하는 당신의 본질",
    subtitle1: "사고·성격·적성을 모두 시각화",
    subtitle2: "5분이면 강점과 약점이 보입니다",
    subtitle3: "모든 진단이 당신의 데이터가 됩니다",
    cta_primary: "진단 시작하기",
    cta_secondary: "카탈로그 보기",
    disclaimer: "참고 정보 / 비의료",
  },
  categories: {
    ability: "능력",
    personality: "성격",
    mental: "정신",
    aptitude: "적성",
    traits: "특성",
  },
  catalog: {
    title: "모든 진단",
    subtitle: "17개 / 5 카테고리",
    filter_all: "전체",
    duration: "분",
    difficulty: { easy: "초급", medium: "중급", hard: "고급" },
    question_count: "문항",
    start: "시작",
  },
  quiz: {
    question: "문항",
    of: "/",
    next: "다음",
    prev: "이전",
    submit: "결과 보기",
    progress: "진행도",
    exit: "나가기",
    required: "선택지를 골라주세요",
    submitting: "채점 중…",
  },
  result: {
    overall: "종합 점수",
    type_label: "유형",
    share_link: "이 링크로 결과 공유",
    back_to_catalog: "다른 진단 받기",
    view_mypage: "마이페이지에서 이력 보기",
    premium_title: "상세 분석 잠금 해제",
    premium_subtitle: "프리미엄으로 아래 모든 내용을 확인할 수 있습니다:",
    feature_breakdown: "상세 점수 분석",
    feature_cause: "원인 분석",
    feature_plan: "개선 플랜",
    feature_pdf: "PDF 리포트(A4)",
    price: "¥980",
    price_note: "(Stripe로 안전 결제)",
    price_free: "무료",
    price_free_note: "(기간 한정 · 100% 무료)",
    unlock_button: "Stripe로 결제",
    unlock_button_free: "무료로 해제",
    unlock_requires_auth: "로그인 후 해제할 수 있습니다",
    unlock_save_first: "먼저 계정으로 결과를 저장하세요",
    unlocking: "Stripe 화면으로 이동 중…",
    free_only_notice: "무료 버전은 종합 점수와 유형만 표시됩니다.",
    compliance_note:
      "이 진단은 참고 정보로 의료 진단이 아닙니다. 단정적이거나 불안을 조장하는 표현을 사용하지 않습니다.",
  },
  premium: {
    title: "상세 분석 리포트",
    summary: "종합 소견",
    strengths: "강점",
    weaknesses: "성장 영역",
    improvements: "개선 제안",
    dimensions: "차원별 점수",
    download_pdf: "PDF 다운로드",
    pdf_soon: "PDF 출력(곧 제공)",
  },
  mypage: {
    title: "마이 페이지",
    subtitle: "이력·점수 추이·획득 배지",
    total: "진단 수",
    average: "평균 점수",
    premium_count: "해제 수",
    categories_covered: "달성 카테고리",
    trend_title: "점수 추이",
    history_title: "진단 이력",
    badges_title: "획득 배지",
    unlock_3_title: "종합 분석 해제",
    unlock_3_desc: "{n}회 더 진단하면 종합 분석이 해제됩니다",
    unlocked: "종합 분석이 해제되었습니다",
    no_history: "아직 진단을 받지 않았습니다. 첫 진단을 시작해보세요.",
  },
  auth: {
    login_title: "로그인",
    register_title: "계정 만들기",
    email: "이메일",
    password: "비밀번호(6자 이상)",
    name: "표시 이름(선택)",
    login_btn: "로그인",
    register_btn: "가입하기",
    go_register: "계정이 없으신가요? 가입",
    go_login: "이미 계정이 있으신가요? 로그인",
    anon_note: "진단은 무료이며 익명입니다. 결과 저장과 유료 기능에는 계정이 필요합니다.",
    success_register: "가입이 완료되었습니다",
    success_login: "로그인했습니다",
    consent_section: "동의 사항",
    consent_required: "필수 항목에 동의해 주세요",
    accept_terms_pre: "",
    terms_link: "이용약관",
    accept_terms_post: "에 동의합니다",
    accept_privacy_pre: "",
    privacy_link: "개인정보 처리방침",
    accept_privacy_post: "을 읽었으며 개인정보 처리에 동의합니다",
    accept_age: "본인은 16세 이상이며, 필요한 경우 법정대리인의 동의를 받았습니다",
    accept_marketing: "새 진단·프로모션 메일 받기",
    optional: "선택",
  },
  landing: {
    status_online: "시스템 온라인",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "17 진단",
    status_langs: "14 언어",
    status_ai: "AI · 활성",
    title_line1: "진단으로 발견하는",
    title_line2: "당신의 본질.",
    trust_diagnostics: "진단",
    trust_languages: "언어",
    trust_per_test: "1회",
    hud_readout: "주요 측정값",
    hud_score_unit: "/100 종합",
    hud_band: "밴드 · GOLD",
    hud_dimensions: "차원",
    hud_dimensions_status: "3 / 3 활성",
    hud_syslog: "시스템 로그",
    cat_eyebrow: "// 카테고리",
    cat_title_pre: "5 카테고리 · ",
    cat_title_highlight: "17 진단",
    view_all: "전체 보기",
    proto_eyebrow: "// 프로토콜",
    proto_title_pre: "3 단계로 ",
    proto_title_highlight: "본질을 해제.",
    step1_title: "진단 선택",
    step1_body: "17개 중에서 선택, 익명 가능.",
    step2_title: "5분 응답",
    step2_body: "진행 바와 배지가 동기를 부여.",
    step3_title: "AI로 해제",
    step3_body: "상세 점수·플랜·PDF 제공.",
    final_eyebrow: "// 준비됐나요?",
    final_title_pre: "당신의 본질을 ",
    final_title_highlight: "5분 안에.",
    final_subtitle: "5분이면 강점과 약점이 보입니다",
    final_button: "지금 진단 시작",
  },
  footer: {
    tagline: "사고·성격·적성을 기록하는 진단 플랫폼",
    rights: "All rights reserved.",
    legal: "법적 정보",
    privacy: "개인정보",
    terms: "이용약관",
    about_label: "운영 회사",
    compliance_label: "국제 컴플라이언스",
    tokushoho_label: "특정상거래법 표기",
    data_protection_label: "데이터 보호(국제 대응)",
    data_request_label: "데이터 삭제 / 옵트아웃",
    disclaimer_label: "면책",
    disclaimer_full:
      "본 서비스는 참고 정보 제공을 목적으로 하며 의료 행위가 아닙니다. 단정적이거나 불안을 조장하는 표현을 사용하지 않습니다.",
  },
  badges: {
    "first-diagnosis": "첫 진단",
    "three-diagnostics": "3회 달성",
    "five-diagnostics": "5회 달성",
    "ten-diagnostics": "10회 달성",
    "high-performer": "하이 퍼포머",
    "premium-user": "프리미엄 사용자",
  },
  lang_selector: "언어",
  payment: {
    processing_title: "결제 확인 중…",
    processing_subtitle: "Stripe에서 돌아왔습니다. 상세 분석을 생성하고 있습니다(최대 20초)",
    success: "결제 완료 — 상세 분석이 해제되었습니다",
    expired: "결제 세션이 만료되었습니다. 다시 시도해 주세요.",
    error: "결제 확인에 실패했습니다. 지원팀에 문의해 주세요.",
  },
};
export default ko;
